import {svgIconWrapper} from '../svg-icon-wrapper';

import BriefcaseRegular from './briefcase-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BriefcaseRegular {...validProps} />;
}
SvgComponent.iconName = 'briefcaseRegular';

export const BriefcaseRegularIcon = svgIconWrapper(SvgComponent);
